<template>
<m-pageframe
    title="Contact Request Details"
    :color="pageframe_color"
>
<v-container
  fluid
  style="padding-left: 30px; padding-right: 30px"
> 
    <link-back
      text="All Contact Requests"
      class="mb-4"
      :to="{
        name: 'search-inbox-contact-requests-without-start-inbox',
        params: { organization_id: $rc.$state.getOrganizationId() }
      }"
    />

      <m-contact-request-card
          :contact_request="contact_request"
          :inbox_summary="inbox_summary"
          v-if="contact_request != null"
      />

       <m-payment-card
            v-if="payment != null"
            :payment="payment"
            v-on:changed="doUpdate"
      />
      
    <div
      style="text-align: right"
    >
      <a v-on:click="onClickTechnicalDetails">Full Connection Process Technical Details</a>
    </div>

    <div
        v-if="inbox_hours_auto_replies != null && inbox_hours_auto_replies.length > 0"
    >
        <h2>Auto Replies</h2>

        <v-data-table
            :headers="auto_reply_headers"
            :items="inbox_hours_auto_replies"
            :items-per-page="100"
            class="elevation-1"

            hide-default-footer
        >
            <template v-slot:item.time="{ item }">
                {{prettyTime(item.time)}}
            </template>

            <template v-slot:item.show_team_member_bot="{}">
              Bot
            </template>

        </v-data-table>
    </div>

    <div
      v-if="employee_notifications != null && employee_notifications.length > 0"
    >
      <h2>Notifications</h2>

      <v-data-table
          :headers="headers"
          :items="employee_notifications"
          :items-per-page="100"
          class="elevation-1"

          hide-default-footer
      >
        <template v-slot:item.time="{ item }">
          {{prettyTime(item.time)}}
        </template>

        <template v-slot:item.pretty_send_status_in_app="{ item }">
            {{prettySendStatusInApp(item.send_status_in_app)}}
        </template>

        <template v-slot:item.pretty_send_status_personal_device="{ item }">
            {{prettySendStatusPersonalDevice(item.send_status_personal_device)}}
        </template>

      </v-data-table>
    </div>

    <m-log-view-dialog
      ref="detail-dialog"
    />

</v-container>
</m-pageframe>
</template>

<script>
const Time = require('@/js/time.js');

export default {
  data() {
    return {
      contact_request_id: null,
      contact_request: null,
      inbox_summary: null,
      employee_notifications: null,
      inbox_hours_auto_replies: null,
      payment: null,

      auto_reply_headers: [
       { text: 'Time', value: 'time' },
       { text: 'RedChirp User', value: 'show_team_member_bot' },
       { text: 'Message', value: 'message' },
      ],

      headers: [
        { text: 'Time', value: 'time' },
        { text: 'RedChirp User', value: 'employee_label' },
        { text: 'Message', value: 'text_in_app_notification' },
        { text: 'Notified in App', value: 'pretty_send_status_in_app' },
        { text: 'Notified Personal Device', value: 'pretty_send_status_personal_device' },
      ],
    }
  },

  mounted () {
    this.contact_request_id = this.$route.params.contact_request_id;
    this.doUpdate();
  },

  methods: {
    doUpdate() {
      this.$rc.showSpinner();

      this.$rc.getInboxContactRequestProfile(
        this.contact_request_id,
        (data) => {
          this.inbox_hours_auto_replies = data.inbox_contact_request_profile.inbox_hours_auto_replies;
          this.contact_request = data.inbox_contact_request_profile.contact_request;
          this.inbox_summary = data.inbox_contact_request_profile.inbox_summary;
          this.employee_notifications = data.inbox_contact_request_profile.employee_notifications;
          this.payment = data.inbox_contact_request_profile.payment;

          this.getContactRequestSources();
        },
        () => {
          this.$rc.hideSpinner();
        }
      );
    },

    getContactRequestSources() {
      this.$rc.rest({
        spinner: false,
        endpoint: 'GET: /api/v1/contact-requests/:contact_request_id/summary',

        params: {
          contact_request_id: this.contact_request_id,
        },

        on_success: (data) => {
          this.contact_request = {
            ...this.contact_request,
            source: data.contact_request.source,
            source_detail: data.contact_request.source_detail,
          }
          this.$rc.hideSpinner();
        },

        on_error: (error) => {
          this.$rc.hideSpinner();
        },
      });
    },

    prettyTime(time)
    {
      return Time.getTimeAndDate(time);
    },
    prettySendStatusInApp(send_status_in_app)
    {
        if (send_status_in_app == 'not-sent')
        {
            return "No";
        }
        else
        {
            return "Yes";
        }
    },
    prettySendStatusPersonalDevice(send_status_personal_device)
    {
        switch (send_status_personal_device)
        {
            case "sent-fail-dnd": return "No (User in DND)";
            case "sent-fail-no-personal-devices-that-accept-sms": return "No (No Personal Device Accepts SMS)";
            case "sent-success": return "Yes";
            case "not-sent":
            default: return "No";
        }
    },
    onClickViewConversation(item)
    {
      let contact_request_id = item.contact_request_id;

      this.$rc.showSpinner();

      this.$rc.getContactRequestConversationLink(
        contact_request_id,

        (data) => {
          this.$rc.hideSpinner();

          let conversation_link = data.conversation_link;

          if ( conversation_link == null )
          {
            this.$rc.alert('Error','Unable to find conversation');
            return;
          }

          this.$router.push({
            'name': 'home-routed',
            'params' : conversation_link,
          })
            .catch(e=>{});
        },

        () => {
          this.$rc.hideSpinner();
          this.$rc.alert('Error','Unable to find conversation');
        },
      );
    },

    onClickTechnicalDetails()
    {
      //this.contact_request_id
      this.$refs['detail-dialog'].showDialog({
         'type': 'contact-request-connection-process',
          'crcp_contact_request_id': this.contact_request_id,
      });
    },
  },

  computed: {

    pageframe_color() {
      if ( this.employee_profile != null && this.employee_profile.employee_account.employee_id != this.$rc.$state.employee_id )
        return '#5D647C';

      // primary
      return '#F24653';
    },
  },
}
</script>

<style lang="scss" scoped>
.heading {
  font-weight: bold;
}
</style>